
import React from "react";
import { XAxis } from "../helper/chart/x-axis";
import { YAxis } from "../helper/chart/y-axis";
import { rem_to_px } from "../helper/px";
import { getRGB } from "../../lib/color";

/**
 * Canvas chart component!
 */
class Chart extends React.Component {

  constructor(props) {
    super(props);

    this.updateSize(props);
  }

  updateSize = props => {

    this.widthPx = rem_to_px(props.widthRem);
    this.heightPx = rem_to_px(props.heightRem);
    this.widthRem = props.widthRem;
    this.heightRem = props.heightRem;
  };

  componentDidMount = () => {
    const axisHeightPx = rem_to_px(this.props.xAxisHeightRem);
    const axisWidthPx = rem_to_px(this.props.yAxisWidthRem);

    this.xAxis = new XAxis(() => {
      return {
        left: axisWidthPx,
        right: this.widthPx,
        bottom: this.heightPx,
        top: this.heightPx - axisHeightPx,
      }
    });
    this.yAxis = new YAxis(() => {
      return {
        left: 0,
        right: axisWidthPx,
        top: 0,
        bottom: this.heightPx - axisHeightPx,
      }
    });

    this.updateCanvas();
  };

  componentDidUpdate = () => {
    this.updateSize(this.props);
    this.updateCanvas();
  };

  // DOES NOT WORK
  clearCanvas = (ctx) => {
    // I have lots of transforms right now
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    // Will always clear the right space
    ctx.clearRect(0, 0, this.widthPx, this.heightPx);
    ctx.restore();
    // Still have my old transforms
  };

  updateCanvas = () => {
    const canvas = this.refs.canvas;
    const ctx = canvas.getContext("2d");
    const tickData = this.props.tickData;
    const timeline = this.props.timeline;

    // THIS is how you reset the HTML canvas?? Lame...
    canvas.width = canvas.width;

    this.xAxis.render(canvas, timeline);
    this.yAxis.render(canvas, tickData);

    for(let i=0; i < tickData.length; i++) {
      ctx.strokeStyle = getRGB(tickData[i].color);
      ctx.beginPath();

      for(let j=0; j < tickData[i].data.length; j++) {
        let x = this.xAxis.tickToX(j);
        let y = this.yAxis.valueToY(tickData[i].data[j]);
        if (j === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }
      ctx.stroke();
    }
  };

  render = () => {
    return (
      <canvas
        ref="canvas"
        width={this.widthPx}
        height={this.heightPx}/>
    );
  }
}

export { Chart };
